import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Container, Row, Col } from 'react-bootstrap';
import styles from './AboutClinic.module.css';
import clinicImg from '../assets/card/especialistas.webp';

const AboutClinic = () => {

    useEffect(() => {
        AOS.init({ duration: 2000 });
    }, []);

    return (
        <div className={styles.fondo}>
            <section className={styles.aboutWrapper}>
                <Container>
                    <Row className={`align-items-center ${styles.aboutRow}`}>
                        <Col md={6} data-aos="fade-right">
                            <img
                                src={clinicImg}
                                alt="Clínica Dental"
                                className={styles.aboutImage}
                            />
                        </Col>
                        <Col md={6} data-aos="fade-left">
                            <div className={styles.sectionTitle}>
                                <h1>Sobre Nuestra Clínica Dental</h1>
                            </div>
                            <p className={styles.aboutText}>
                                Con más de 15 años de experiencia, en nuestra clínica dental nos especializamos en ofrecer atención odontológica de alta calidad, con un enfoque profesional, humano y personalizado. Nuestro equipo está formado por especialistas en diversas áreas como ortodoncia, implantología, estética dental y odontología general, lo que nos permite brindar soluciones integrales adaptadas a cada paciente.
                            </p>
                            <p className={styles.aboutText}>
                                Gracias a una formación constante y al uso de tecnología de vanguardia, garantizamos diagnósticos precisos y tratamientos eficaces en un entorno cómodo y seguro. Nos comprometemos a hacer que cada visita sea una experiencia positiva, con un trato cercano y empático que prioriza la confianza y el bienestar del paciente.
                            </p>
                            <p className={styles.aboutText}>
                                Durante estos años, hemos transformado cientos de sonrisas y aliviado muchas molestias, convirtiéndonos en una clínica de referencia para quienes buscan atención dental profesional y confiable. Aquí no solo cuidamos la salud bucal, cuidamos personas con dedicación y pasión.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
};

export default AboutClinic;

